if (typeof document === "undefined") return;
var createStylesheet = function(chunkId, fullhref, oldTag, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"umi": 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"src_umi_umi_ts":1,"src_pages_Dashboard_DailyDashboard_DailySalesBranchS2Pivot_tsx-src_pages_Dashboard_DailyDashb-bb6982":1,"p__Forms__PublicFill":1,"p__Home__index":1,"p__Home__AiAssistant__index":1,"p__Home__Calendar__index":1,"p__User__DigitalCard__index":1,"p__Admin__Overview__index":1,"p__Admin__SyncTools__index":1,"p__Admin__ItConsole__index":1,"p__Dashboard__index":1,"p__Dashboard__BranchPerformance__index":1,"p__Dashboard__PromotionPerformance__index":1,"p__Dashboard__CategoryBrandPerformance__index":1,"p__Dashboard__BranchFinancialPerformance__index":1,"p__Dashboard__SingleBranchPerformance__index":1,"p__Dashboard__InventoryDashboard__index":1,"p__Dashboard__InventoryHealth__index":1,"p__Home__Dashboard__index":1,"p__Report__Landing__index":1,"p__Report__OutletSales__index":1,"p__Report__BranchMonthlySales__index":1,"p__Report__BranchDailySales__index":1,"p__Report__BranchMonthlySales__DailyBreakdown":1,"p__Report__BranchDailySales__DayBreakdown":1,"p__Report__YearlySalesComparison__index":1,"p__Report__ReceiptAnalysis__index":1,"src_pages_Report_SalesBySku_SalesBySkuS2Pivot_tsx-src_pages_Report_SalesBySku_SkuReceiptDrill-d864ed":1,"p__Report__SalesBySku__index":1,"src_pages_Report_SalesByPromotion_SalesByPromotionS2Pivot_tsx-src_pages_Report_OutletSales_in-c8dc68":1,"p__Report__CouponUsage__index":1,"p__Report__PoDetails__index":1,"p__Report__StockInventory__index":1,"p__Report__StockAging__index":1,"p__Report__SkuMovementHealth__index":1,"p__Report__StockMovement__index":1,"p__Report__StockMovement__Maximized":1,"p__Tools__index":1,"p__Tools__SkuChecker__index":1,"p__Tools__SkuCheckDigits__index":1,"p__Tools__GrnHousekeeping__index":1,"p__Tools__SkuImages__index":1,"p__Tools__PDFLayoutExtractor__index":1,"p__Tools__StockTake__Scan__index":1,"src_pages_Commercial_index_less":1,"p__Report__CounterFinalizedPayments__index":1,"p__XERP__index":1,"p__User__Login__index":1,"p__RetailOperations__DailyOperationalDashboard__index":1,"p__RetailOperations__PosExceptions__index":1,"p__RetailOperations__StationeryManagement__index":1,"p__RetailOperations__BranchSalesTarget__index":1,"p__PurchaseOrderManagement__POModuleLanding__index":1,"p__PurchaseOrderManagement__MasterPO__index":1,"p__PurchaseOrderManagement__MasterPO__FormPage":1,"p__EcommerceManage__Overview__index":1,"p__EcommerceManage__ShopifyPriceUpdate__index":1,"src_pages_HR_JobApplications_public_less":1,"p__HR__HRModuleLanding__index":1,"p__HR__JobApplications__index":1,"src_pages_HR_JobApplications_detail_less":1,"p__HR__JobApplications__ApplicationForm":1,"src_pages_HR_Appraisals_index_less":1,"src_pages_HR_Appraisals_AppraisalTranslateWidget_tsx-src_pages_HR_Appraisals_QuestionJournal_-871cce":1,"p__HR__OrgChart__index":1,"p__HR__RecruitmentChatbot__Conversations__index":1,"p__HR__RecruitmentChatbot__Knowledge__index":1,"p__HR__RecruitmentChatbot__Inquiries__index":1,"p__HR__RecruitmentChatbot__Settings__index":1,"p__Forms__Available":1,"p__Forms__index":1,"p__Forms__Design":1,"p__Forms__Fill":1,"p__Forms__Submissions":1,"p__VisitorManagement__index":1,"p__VisitorManagement__Register__index":1,"p__VisitorManagement__Visits__index":1,"p__Knowledge__index":1,"p__Knowledge__ArticleView__index":1,"p__Knowledge__ArticleEdit__index":1,"p__Report__OutletSales__PivotExpand":1,"p__RetailOperations__PosExceptions__PivotExpand":1,"p__Report__StockAging__StockAgingPivotExpand":1,"umi__plugin-layout__Layout":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

var oldTags = [];
var newTags = [];
var applyHandler = function(options) {
	return { dispose: function() {
		for(var i = 0; i < oldTags.length; i++) {
			var oldTag = oldTags[i];
			if(oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
		}
		oldTags.length = 0;
	}, apply: function() {
		for(var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
		newTags.length = 0;
	} };
}
__webpack_require__.hmrC.miniCss = function(chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
	applyHandlers.push(applyHandler);
	chunkIds.forEach(function(chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if(!oldTag) return;
		promises.push(new Promise(function(resolve, reject) {
			var tag = createStylesheet(chunkId, fullhref, oldTag, function() {
				tag.as = "style";
				tag.rel = "preload";
				resolve();
			}, reject);
			oldTags.push(oldTag);
			newTags.push(tag);
		}));
	});
}